import React, { useEffect, useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl } from '@material-ui/core';
import { useGetAPI } from '../../Utils/useGetAPI';
import {
  BackstageIdentityApi,
  microsoftAuthApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  useApi,
} from '@backstage/core-plugin-api';

import axios from 'axios';
import { Select } from '@backstage/core-components';
import Alert from '@mui/material/Alert';

type departmentDropdownType = {
  dept: string;
};

type optionsArrayType = [
  {
    label: string;
    value: string;
  },
];

export const DepartmentDropdown = ({ onChange }: FieldProps<string>) => {
  const [formState, setFormState] = useState<departmentDropdownType>({
    dept: '',
  });

  const [options, setOptions] = useState<optionsArrayType>([
    { label: 'Loading...', value: 'loading' },
  ]);

  const [error, setError] = useState<boolean>(false);

  const url: string = useGetAPI();
  const identityAPI: OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi = useApi(microsoftAuthApiRef);

  onChange(formState);

  const getData = async () => {
    const token: string = await identityAPI.getIdToken();

    await axios
      .get(`${url}/v1/api/devops/departments`, {
        headers: {
          Authorization: `Basic ${token}`,
        },
      })
      .then(res => {
        const repoArray =
          res !== undefined && res.data.department_units !== null
            ? res.data.department_units
            : [];

        const scrubRepoArray = Array.from(repoArray)
          .sort()
          .map(repo => {
            return {
              label: repo,
              value: repo,
            };
          });

        scrubRepoArray.unshift({
          label: 'Select a Department',
          value: '',
        });

        setOptions(scrubRepoArray);
        setError(false);
      })
      .catch(e => {
        setError(true);
      });
  };

  if (options.length <= 1 && error === false) {
    getData();
  }

  return (
    <FormControl margin="normal">
      {error === false ? (
        <Select
          native
          label="Departments"
          onChange={selected => {
            setFormState({
              dept: selected.toString(),
            });
          }}
          items={options}
          selected={formState.dept}
        />
      ) : (
        <Alert severity="error">
          There was an issue with your request. Please wait a few minutes and
          try again.{' '}
        </Alert>
      )}
    </FormControl>
  );
};

export const departmentropdownValidation = (
  value: departmentDropdownType,
  validation: FieldValidation,
) => {
  if (value.dept === undefined || value.dept.length < 1) {
    validation.addError('Please select a repo from the dropdown.');
  }
};
